import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import vegas from "../vegas.jpg";
import itencov from "../assets/itencov.png";
import iten1 from "../assets/iten1.png";
import "@fontsource/oswald";

const JackpotVip = () => {
    return (
        <div
            className="min-h-screen bg-cover bg-center flex flex-col text-white"
            style={{
                backgroundImage: `url(${vegas})`,
            }}
        >
            <div className="bg-black bg-opacity-80 min-h-screen">
                <Header />

                <div className="animate-fade-in">
                    <div className="flex justify-center items-center p-6">
                        <main
                            className="relative bg-white bg-opacity-10 text-white rounded-lg shadow-xl max-w-5xl w-full px-6 md:px-10 py-10"
                            style={{
                                fontFamily:
                                    "'Oswald', sans-serif",
                            }}
                        >
                            <div className="text-center">
                                <h1
                                    className="font-bold text-[#b42520] tracking-tight"
                                    style={{
                                        fontFamily:
                                            "'Oswald'",
                                        fontSize:
                                            "52px",
                                        fontWeight:
                                            "bold",
                                        color:
                                            "#b42520",
                                    }}
                                >
                                    Jackpot VIP
                                </h1>

                                <h2 className="mt-3 text-3xl font-extrabold text-white">
                                    Las Vegas Trip Planning
                                </h2>
                            </div>

                            <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                                <div className="space-y-4 text-lg leading-relaxed text-white/95">
                                    <p>
                                        Skip the stress and let an expert Las Vegas concierge plan your perfect trip. You'll be matched with a dedicated concierge who will begin planning your visit through personalized video calls before you arrive.
                                    </p>

                                    <p>
                                        We'll create a custom itinerary tailored to your group, style, and budget, featuring insider recommendations, hidden gems, and can't-miss experiences.
                                    </p>

                                    <p>
                                        By leveraging our local partnerships, we'll help you access exclusive perks, discounted pricing, and special offers whenever available.
                                    </p>

                                    <p>
                                        Once your itinerary is finalized, we'll handle the bookings whenever possible and provide concierge support throughout your stay.
                                    </p>

                                    <div className="mt-8 rounded-xl bg-black/30 border border-white/20 p-6">
                                        <h3 className="text-2xl font-extrabold text-[#b42520] mb-4">
                                            Your Jackpot VIP Experience
                                        </h3>

                                        <ul className="list-disc pl-6 space-y-3 text-lg text-white marker:text-white">
                                            <li className="text-white">
                                                Personalized pre-arrival video planning
                                            </li>

                                            <li className="text-white">
                                                Custom itinerary with expert recommendations
                                            </li>

                                            <li className="text-white">
                                                Access to exclusive perks and partner discounts
                                            </li>

                                            <li className="text-white">
                                                Booking assistance for restaurants, shows, clubs, and more
                                            </li>

                                            <li className="text-white">
                                                Concierge support during your trip
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="flex flex-col items-center gap-5">
                                    <div className="border-2 border-gray-300 rounded-lg p-1 bg-white w-full max-w-[390px]">
                                        <img
                                            className="h-full w-full object-contain"
                                            src={itencov}
                                            alt="Jackpot VIP custom Las Vegas itinerary cover"
                                        />
                                    </div>

                                    <div className="border-2 border-gray-300 rounded-lg p-1 bg-white w-full max-w-[390px]">
                                        <img
                                            className="h-full w-full object-contain"
                                            src={iten1}
                                            alt="Jackpot VIP personalized Las Vegas itinerary"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="mt-12 border-t border-white/20 pt-8 text-center">
                                <h3 className="text-2xl font-extrabold text-white">
                                    Ready to plan your Vegas trip?
                                </h3>

                                <p className="mt-3 text-lg text-white/90">
                                    Tell us about your group, your dates, and the kind of experience you're looking for.
                                </p>

                                <Link
                                    to="/request-quote"
                                    className="mt-6 inline-flex items-center justify-center rounded-lg bg-[#b42520] px-8 py-4 text-white text-xl font-extrabold transition hover:bg-[#941c18] hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-[#b42520]"
                                >
                                    Request a Quote
                                </Link>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JackpotVip;